import { defineMessages } from 'react-intl';

const translations = {
  title: {
    id: 'pages.externalAccess.title',
    defaultMessage: 'External access',
    description: 'title of the external access page',
  },
  externalAccess: {
    invite: {
      button: {
        id: 'pages.externalAccess.invite.button',
        defaultMessage: 'Invite',
        description: 'title of the invite user button',
      },
      title: {
        id: 'pages.externalAccess.invite.title',
        defaultMessage: 'Invite user',
        description: 'title of the invite user drawer',
      },
    },
    request: {
      button: {
        id: 'pages.externalAccess.request.button',
        defaultMessage: 'Request access',
        description: 'title of the request access button',
      },
      title: {
        id: 'pages.externalAccess.request.title',
        defaultMessage: 'Request access',
        description: 'title of the request access drawer',
      },
    },
  },
  feedback: {
    userNotFound: {
      id: 'pages.externalAccess.feedback.userNotFound',
      defaultMessage: 'User could not be found',
      description: 'error feedback message user not found',
    },
    inviteSent: {
      id: 'pages.externalAccess.feedback.inviteSent',
      defaultMessage: 'Invitation has been sent',
      description: 'success feedback message of the sent invite action',
    },
    inviteNotSent: {
      id: 'pages.externalAccess.feedback.inviteNotSent',
      defaultMessage: 'User invitation could not be sent',
      description: 'error feedback message of the sent invite action',
    },
    accessRequested: {
      id: 'pages.externalAccess.feedback.accessRequested',
      defaultMessage: 'Access has been requested',
      description: 'success feedback message of the request access action',
    },
    accessNotRequested: {
      id: 'pages.externalAccess.feedback.accessNotRequested',
      defaultMessage: 'Access could not be requested',
      description: 'error feedback message of the request access action',
    },
    accessAlreadyRequested: {
      id: 'pages.externalAccess.feedback.accessAlreadyRequested',
      defaultMessage: 'Access already requested',
      description: 'duplicate feedback message of the request access action',
    },
    requestRevoked: {
      id: 'pages.externalAccess.feedback.requestRevoked',
      defaultMessage: 'Request has been revoked',
      description: 'success feedback message of the revoke request action',
    },
    requestNotRevoked: {
      id: 'pages.externalAccess.feedback.requestNotRevoked',
      defaultMessage: 'Request could not be revoked',
      description: 'error feedback message of the revoke request action',
    },
    requestApproved: {
      id: 'pages.externalAccess.feedback.requestApproved',
      defaultMessage: 'Request has been approved',
      description: 'success feedback message of the approve request action',
    },
    requestNotApproved: {
      id: 'pages.externalAccess.feedback.requestNotApproved',
      defaultMessage: 'Request could not be approved',
      description: 'error feedback message of the approve request action',
    },
    requestDeclined: {
      id: 'pages.externalAccess.feedback.requestDeclined',
      defaultMessage: 'Request has been declined',
      description: 'success feedback message of the decline request action',
    },
    requestNotDeclined: {
      id: 'pages.externalAccess.feedback.requestNotDeclined',
      defaultMessage: 'Request could not be declined',
      description: 'error feedback message of the decline request action',
    },
    inviteRevoked: {
      id: 'pages.externalAccess.feedback.inviteRevoked',
      defaultMessage: 'Invite has been revoked',
      description: 'success feedback message of the revoke invite action',
    },
    inviteNotRevoked: {
      id: 'pages.externalAccess.feedback.inviteNotRevoked',
      defaultMessage: 'Invite could not be revoked',
      description: 'error feedback message of the revoke invite action',
    },
    inviteApproved: {
      id: 'pages.externalAccess.feedback.inviteApproved',
      defaultMessage: 'Invite has been accepted',
      description: 'success feedback message of the approve invite action',
    },
    inviteNotApproved: {
      id: 'pages.externalAccess.feedback.inviteNotApproved',
      defaultMessage: 'Invite could not be accepted',
      description: 'error feedback message of the approve invite action',
    },
    inviteDeclined: {
      id: 'pages.externalAccess.feedback.inviteDeclined',
      defaultMessage: 'Invite has been declined',
      description: 'success feedback message of the decline invite action',
    },
    inviteNotDeclined: {
      id: 'pages.externalAccess.feedback.inviteNotDeclined',
      defaultMessage: 'Invite could not be declined',
      description: 'error feedback message of the decline invite action',
    },
  },
  subNavigation: {
    approved: {
      id: 'pages.externalAccess.subNavigation.approved',
      defaultMessage: 'Approved',
      description: 'label of the approved tab on the external access page',
    },
    requested: {
      id: 'pages.externalAccess.subNavigation.requested',
      defaultMessage: 'Requested',
      description: 'label of the requested tab on the external access page',
    },
    invited: {
      id: 'pages.externalAccess.subNavigation.invited',
      defaultMessage: 'Invited',
      description: 'label of the invited tab on the external access page',
    },
    myInvites: {
      id: 'pages.externalAccess.subNavigation.myInvites',
      defaultMessage: 'My invites',
      description: 'label of the my invites tab on the external access page',
    },
    myRequests: {
      id: 'pages.externalAccess.subNavigation.myRequests',
      defaultMessage: 'My requests',
      description: 'label of the my requests tab on the external access page',
    },
  },
};

export default defineMessages(translations);
